export default __webpack_public_path__ + "static/Parental Code of Conduct-f7be73f3380c67cd00d5d44f5f81946f.pdf";